<template>
    <v-col
        cols="12"
        offset="0"
        class="mt-0"
    >
        <Card
            v-for="card in phasen"
            :key="card.id"
            main
            :elements="card.content"
            class="seminar-card"
            flat
        />
    </v-col>
</template>

<script>
import Card from "@/components/Card/Card.vue";

export default {
    components: {
        Card
    },
    data: () => ({
        phasen: [
            {
                id: 1,
                modifier: "narrowContent",
                content: [
                    {
                        type: "title_image",
                        text: "1. Bewerbungsphase",
                        image: "seminar/application",
                        fileTypes: ["jpg"],
                        height: 200
                    },
                    {
                        type: "text",
                        text: `In der ersten Phase können sich Schüler*innen für Aktion Zukunft bewerben. 
                        Dazu ist es nötig, dass sie das Bewerbungsformular bis zum 15. September 2021 ausfüllen. 
                        Voraussetzungen für die Teilnahme an dem Programm finden Sie hier:`
                    },
                    {
                        type: "actions",
                        buttons: [
                            {
                                text: "Voraussetzungen",
                                type: "internal",
                                route: "/seminar/info"
                            }
                        ]
                    },
                    {
                        type: "divider"
                    }
                ]
            },
            {
                id: 2,
                content: [
                    {
                        type: "title_image",
                        text: "2. Individuelle Mentoring-Phase",
                        image: "seminar/mentoring",
                        fileTypes: ["jpg"],
                        height: 200,
                        textColor: "white"
                    },
                    {
                        type: "text",
                        text: `Um die individuellen Stärken der Teilnehmer*innen voll zu entfalten, erhalten 
                        alle Teilnehmer*innen während der Gesamtdauer des Projektes individuelle Mentor*innen, 
                        die sie bei jedem Schritt ihrer Projektarbeit unterstützen. Während der Mentoring-Phase 
                        ab September 2021 nehmen die Teilnehmer*innen an Workshops und Einzelcoachings 
                        teil, welche je nach Infektionsgeschehen flexibel online oder in Präsenz stattfinden. Im 
                        Rahmen des Mentorings erlernen sie grundlegende Fähigkeiten des Projektmanagements und 
                        erarbeiten erste Konzepte für ihre Projektideen. Außerdem werden die Teilnehmer*innen ihr 
                        Wissen über die Lage von Geflüchteten in Deutschland und Europa vertiefen, sowie Kenntnisse 
                        über rechtliche und politische Hintergründe zu Integrationsthemen erlangen.`
                    },
                    {
                        type: "divider"
                    }
                ]
            },
            {
                id: 3,
                content: [
                    {
                        type: "title_image",
                        text: "3. Seminarwoche in Berlin",
                        image: "seminar/berlin",
                        fileTypes: ["jpg"],
                        height: 200,
                        textColor: "white"
                    },
                    {
                        type: "text",
                        text: `Anschließend laden wir alle Teilnehmer*innen vom 20.04. bis 24.04.2022 zu einer Seminarwoche 
                        nach Berlin ein, in dessen Rahmen die Projekte gemeinsam mit Expert*innen aus Wissenschaft, 
                        NGOs und Politik weiterentwickelt und die Grundlagen für einen nachhaltigen Projekterfolg 
                        gesetzt werden. Aber auch nach der Seminarwoche können die Teilnehmer*innen weiterhin auf 
                        die Unterstützung durch Aktion Zukunft zählen. So können sich alle Teilnehmer*innen für 
                        eine Startfinanzierung von bis zu 500€ bewerben und den individuellen Rat ihrer Mentor*innen 
                        in Anspruch nehmen.`
                    },
                    {
                        type: "divider"
                    }
                ]
            }
        ]
    })
}
</script>

<style lang="scss">
.seminar-card {
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>